<template>
	<div class="pga-tournament-pool-about-page">
		<div class="pga-tournament-pool-about-page__content">
			<div class="header-section">
				<h3 class="header">PGA Tournament Tiers</h3>
				<router-link :to="{ name: 'create-pool' }" class="create-button btn">Create Pool Now</router-link>
			</div>
			
			<div class="instructions">
				<h4>Entry Instructions</h4>
				<div class="instruction-section">
					<p>For this game, each golfer entered in the current week's PGA tournament is placed in a tier based on their current world ranking. The number and size of the tiers can be different depending on the size and quality of the field.  The setup for the Masters this week is below. </p>
					<table>
						<tr>
							<th>Tier</th>
							<th>Number of Players</th>
						</tr>
						<tr>
							<td>1</td>
							<td>10</td>
						</tr>
						<tr>
							<td>2</td>
							<td>10</td>
						</tr>
						<tr>
							<td>3</td>
							<td>10</td>
						</tr>
						<tr>
							<td>4</td>
							<td>10</td>
						</tr>
						<tr>
							<td>5</td>
							<td>15</td>
						</tr>
						<tr>
							<td>6</td>
							<td>15</td>
						</tr>
						<tr>
							<td>7</td>
							<td>Remaining Field</td>
						</tr>
					</table>

					<p>Each participant in the pool selects one golfer in each tier, along with the winning score-to-par as a tiebreaker.</p>
				</div>
				
				<h4>Scoring Rules</h4>
				<div class="instruction-section">
					<ul>
						<li>
							Each round is scored separately. Golfers with the best score of the round receive 20 points. A golfer receives two fewer points for each stroke they are behind the best score of the round. Anyone 10 or more strokes behind will receive 0 points.  Your top 5 golfers are counted, and any golfers that miss the cut or withdraw will receive 0 points for the rounds they don't complete.
						</li>
						<li>
							Anyone with the tournament champion on their team receives 10 bonus points.
						</li>
					</ul>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>

	export default {

	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/pga/pga-tournament-pool/about';
</style>